@if (hasLoaded) {
  <div class="container-background">
    <div class="row">
      <div class="col-md-12">
        <div class="row gutter">
          <company-events-information
            [event]="event"
            (onEventToolbarAction)="onEventToolbarClick($event)"
            (updateGeneralInfo)="updateEventInfo($event)"
            [isOnUserCalendar]="isOnUserCalendar"
            [permissions]="permissions"
          ></company-events-information>
        </div>
        <div class="row align-top flex gutter">
          <div class="col-md-6">
            <company-events-links
              [webAddresses]="event.companyEventWebAddresses"
              [userCanEdit]="permissions._edit"
            ></company-events-links>
          </div>
          <div class="col-md-6">
            <company-events-notes [note]="event.notes" (updateNote)="updateNote($event)" [userCanEdit]="permissions._edit" ></company-events-notes>
          </div>
        </div>
        <div class="row flex gutter">
          <company-events-attendees [attendees]="attendees"
            [userCanEdit]="permissions._edit"
            [outlookAttendees]="outlookAttendees"
            (updateOutlookAttendees)="updateOutlookAttendees($event, true)"
          ></company-events-attendees>
        </div>
        <div class="row flex gutter">
          @if (permissions._edit) {
            <company-events-outlook [outlookAttendees]="outlookAttendees"></company-events-outlook>
          }
        </div>
      </div>
    </div>
  </div>
}
